import { find } from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_ANSWER_TEMPLATES = 'SET_ANSWER_TEMPLATES';
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';
export const SET_CURRENT_ANSWER_TEMPLATE = 'SET_CURRENT_ANSWER_TEMPLATE';

const data = {
  answerTemplates: [],
  currentAnswerTemplate: {},
  fetching: false,
  answerTemplatesTotal: 0,
  pageSizeDefault: undefined,
};

const actions = {
  async loadAnswerTemplates({ commit }) {
    const answerTemplates = await api.getAnswerTemplates();
    commit(SET_ANSWER_TEMPLATES, { answerTemplates });
  },
  async loadAnswerTemplatesPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(SET_FETCHING);
    return api.getAnswerTemplatesPagination(page, pageSize).then((res) => {
      commit(SET_ANSWER_TEMPLATES, {
        answerTemplates: res.answerTemplates,
        total: res.totalCount,
        moreData,
        pageSizeDefault: res.pageSize,
      });
      return res;
    }).catch((err) => {
      commit(SET_STOP_FETCHING);
      throw err;
    });
  },
  async getAnswerTemplate({ dispatch, state }, { id }) {
    let answerTemplate = find(state.answerTemplates, (template) => template.id === id);
    if (!answerTemplate) { answerTemplate = await api.getAnswerTemplate({ id }); }
    dispatch('setCurrentAnswerTemplate', answerTemplate);
    return answerTemplate;
  },
  setCurrentAnswerTemplate({ commit }, value) {
    commit(SET_CURRENT_ANSWER_TEMPLATE, value);
  },
  clearCurrentAnswerTemplate({ commit }) {
    commit(SET_CURRENT_ANSWER_TEMPLATE, null);
  },
  createAnswerTemplate(_, answerTemplateParams) {
    return api.createAnswerTemplate(answerTemplateParams).then((res) => res);
  },
  updateAnswerTemplate(_, answerTemplateParams) {
    return api.updateAnswerTemplate(answerTemplateParams).then((res) => res);
  },
  async deleteAnswerTemplate({ commit, state }, id) {
    const result = api.deleteAnswerTemplate({ id });
    if (result) {
      const answerTemplates = state.answerTemplates
        .filter((answerTemplate) => answerTemplate.id !== id);
      commit(SET_ANSWER_TEMPLATES, { answerTemplates, total: state.answerTemplatesTotal - 1 });
    }
    return result;
  },
};

const mutations = {
  SET_ANSWER_TEMPLATES(state, {
    answerTemplates, total, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.answerTemplates = state.answerTemplates.concat(answerTemplates);
    } else {
      state.answerTemplates = answerTemplates;
    }
    state.answerTemplatesTotal = total || state.answerTemplatesTotal;
    mutations.SET_STOP_FETCHING(state);
  },
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SET_CURRENT_ANSWER_TEMPLATE(state, value) {
    state.currentAnswerTemplate = value;
  },
};

const store = {
  state: data,
  actions,
  mutations,
  namespaced: true,
};

export default store;
